import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { finalize, Subscription } from 'rxjs';
import { UserSocketService } from './shared/services/user-socket.service';
import { AuthenticationService } from './shared/services/authentication.service';
import { AppService } from './shared/services/app.service';
import { PostHogService } from './shared/services/posthog.service';
import { IUser } from './shared/models/models';
import { PERMISSION_ACCESS, PERMISSIONS } from './shared/modules/permissions/enums/permissions.enum';

@Component({
    standalone: false,
  selector: 'crm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit{
  title = environment?.node_env || 'Production';

  flatFollowupSocketSubscription!: Subscription;
  activityFollowupSocketSubscription!: Subscription;
  userSubscription!: Subscription;

  currentUser: IUser['_id'] | null

  get permissions() { return PERMISSIONS }
  get permissionsAcess() { return PERMISSION_ACCESS }

  flatFollowUps: {
    followUpId: string,
    ownershipId: string,
    projectName: string,
    flatNumber: string,
    applicantName: string,
    triggered: boolean,
    disabled: boolean
  }[] = []

  activityFollowups: {
    activityFollowUpId: string,
    ownershipId: string,
    projectName: string,
    flatNumber: string,
    applicantName: string,
    message: string
  }[] = []

  constructor(
    private userSocketService: UserSocketService,
    private authenticationService: AuthenticationService,
    private appService:AppService,
    private cdr: ChangeDetectorRef,
    private posthogService: PostHogService,
  ) {
    this.userSubscription = this.authenticationService.currentUser.subscribe(currentUser => {
      if (currentUser) {
        this.currentUser = currentUser?._id
        this.fetchFollowUpNotifications()
        this.fetchActivityFollowupNotifications()
        this.flatFollowupSocketSubscription = this.userSocketService.on('flatFollowUp').subscribe((result: any) => {
          if (result?.fetchData) {
            this.fetchFollowUpNotifications();
          }
          this.cdr.detectChanges();
        });
        this.activityFollowupSocketSubscription = this.userSocketService.on('activityFlatFollowUp').subscribe((result: any) => {
          if (result?.fetchData) {
            this.fetchActivityFollowupNotifications();
          }
          this.cdr.detectChanges();
        });
      }
      else {
        this.flatFollowUps = []
        this.activityFollowups = []
        this.currentUser = null;
        this.cdr.detectChanges();
      }
    })
  }

  ngOnInit(): void {
    if(this.currentUser){
      this.fetchFollowUpNotifications()
    }
  }

  //To fetch all the existing followup notifications
  fetchFollowUpNotifications() {
    this.appService.getFollowUpNotifications().subscribe((res) => {
      if (res.data) {
        const result = res.data;
        this.flatFollowUps = []
        result.forEach((each) => {
          this.flatFollowUps.push({ ...each, triggered: false, disabled: false })
        })

        this.cdr.detectChanges();
      }
    })
  }

  //To fetch all the existing activity followup notifications
  fetchActivityFollowupNotifications() {
    this.appService.getActivityFollowupNotifications().subscribe((res) => {
      if (res.data) {
        const result = res.data;
        this.activityFollowups = []
        result.forEach((each) => {
          this.activityFollowups.push({ ...each, disabled: false })
        })
        this.cdr.detectChanges();
      }
    })
  }

  dismissActivityFollowup(activityFollowupId: string) {
    this.activityFollowups = this.activityFollowups.filter((each) => each.activityFollowUpId != activityFollowupId) ?? []
    this.appService.closeActivityFollowupNotification(activityFollowupId).subscribe((res) => { });
    this.cdr.detectChanges();
  }

  triggerCall(followUpId: string, triggered: boolean) {
    if (triggered) return;

    //marking disabled
    this.flatFollowUps = this.flatFollowUps.map(each =>
      each.followUpId === followUpId ? { ...each, disabled: true } : each
    );
    this.cdr.detectChanges();

    this.appService.callFollowUpCustomer(followUpId).pipe(finalize(() => {
      this.flatFollowUps = this.flatFollowUps.map(each =>
        each.followUpId === followUpId ? { ...each, disabled: false } : each
      );
      this.cdr.detectChanges();
    })).subscribe((res) => {
      if (res.success) {
        this.flatFollowUps = this.flatFollowUps.map(each =>
          each.followUpId === followUpId ? { ...each, triggered: true } : each
        );
      }
    })
  }

  dismissFollowUp(followUpId: string) {
    this.flatFollowUps = this.flatFollowUps.filter((each) => each.followUpId != followUpId) ?? []
    this.appService.closeFollowUpNotification(followUpId).subscribe((res) => { });
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription?.unsubscribe();
    }
    if (this.flatFollowupSocketSubscription) {
      this.flatFollowupSocketSubscription?.unsubscribe();
    }
    if (this.activityFollowupSocketSubscription) {
      this.activityFollowupSocketSubscription?.unsubscribe();
    }
  }
}
